import moment from "moment";

/**
 * Format a date
 *
 * @param {String}    str
 * @param {String}    format
 * @param {Boolean}   withTime
 *
 * @returns {String} The formatted date
 */
export default function nonUtcFormatDate(str, format = "MMM DD, YYYY", withTime = false) {
  const date = str || new Date();
  return withTime ? moment(date).format(`${format} , ha`) : moment(date).format(format);
}
